import React from 'react'
import PropTypes from 'prop-types'

import styled from '@emotion/styled'
import { keyframes, css } from '@emotion/react'
import { Flex } from '../Flex'
import { Text } from '../Text'

export const PROGRESSBARMEDIUM_VARIANT_DEFAULT = 'default'
export const PROGRESSBARMEDIUM_VARIANT_SUCCESS = 'success'
export const PROGRESSBARMEDIUM_VARIANT_ERROR = 'error'
export const PROGRESSBARMEDIUM_VARIANT_WARNING = "warning"

const step = 20

const INNER_HEIGHT = 8 // px

const slide = keyframes`
  from {
    background-position-x: 0;
  }
  to {
    background-position-x: ${4 * Math.sqrt(2 * step * step)}px;
  }
`

const handleVariant = ({ variant }) => {
  switch (variant) {
    case PROGRESSBARMEDIUM_VARIANT_DEFAULT:
      return 'border-color: #3DC6F5;'
    case PROGRESSBARMEDIUM_VARIANT_SUCCESS:
      return 'border-color: var(--sushi);'
    case PROGRESSBARMEDIUM_VARIANT_ERROR:
      return 'border-color: var(--persimmon);'
    case PROGRESSBARMEDIUM_VARIANT_WARNING:
      return 'border-color: #FF9000;'
  }
}

const handleBarVariant = ({ variant }) => {
  switch (variant) {
    case PROGRESSBARMEDIUM_VARIANT_DEFAULT:
      return css`
        animation: ${slide} 4s linear infinite;
        will-change: background-position;

        background-color: #3dc6f5;
      `
    case PROGRESSBARMEDIUM_VARIANT_SUCCESS:
      return `
        background-color: var(--mantis);
      `

    case PROGRESSBARMEDIUM_VARIANT_ERROR:
      return `
        background-color: #FF6458;
      `

    case PROGRESSBARMEDIUM_VARIANT_WARNING:
      return `
        background-color: #FF9000;
      `
  }
}

const StyledContainer = styled.div`
  height: 8px;
  width: 100%;
  box-sizing: border-box;
  background-color: #e9e9e9;
  border-radius: 13.5px;
  ${handleVariant};
`

const StyledBar = styled.div`
  height: ${INNER_HEIGHT}px;


  border-radius: ${INNER_HEIGHT / 2}px;

  background-size: ${4 * Math.sqrt(2 * step * step)}px
    ${4 * Math.sqrt(2 * step * step)}px;

  width: ${({ width }) => width}%;
  

  ${handleBarVariant}


  clip-path: path('M ${INNER_HEIGHT / 2} ${INNER_HEIGHT} A ${INNER_HEIGHT /
  2},${INNER_HEIGHT / 2}, 0,0,1 ${INNER_HEIGHT /
  2} 0 L 9999 0 L 9999 ${INNER_HEIGHT}');

  overflow: hidden;
`

export const ProgressBarMedium = ({ className, variant, width }) => {
  return (
    <Flex alignItems='center' gap='8px' className={className}>
      <StyledContainer variant={variant}>
        <StyledBar variant={variant} width={width} />
      </StyledContainer>
      <Text variant='light'>{width + '%'}</Text>
    </Flex>
  )
}

ProgressBarMedium.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  variant: PropTypes.oneOf([
    PROGRESSBARMEDIUM_VARIANT_DEFAULT,
    PROGRESSBARMEDIUM_VARIANT_SUCCESS,
    PROGRESSBARMEDIUM_VARIANT_ERROR,
    PROGRESSBARMEDIUM_VARIANT_WARNING
  ])
}

ProgressBarMedium.defaultProps = {
  variant: PROGRESSBARMEDIUM_VARIANT_DEFAULT
}
